/**
 * @file interpret/pilot.ts
 * @brief Who sees live interpretation on web + desktop while it is a pilot.
 *
 * @details
 * DES, 01-10-2026: roll out behind a flag to one pilot company first. The list
 * comes from `VITE_WEB_INTERPRET_COMPANY_IDS` (build time, Cloudflare Pages env):
 * company ids, comma separated, or "*" for everyone. A user also needs the
 * `interpretation` entitlement, which the route guard checks separately.
 * Users with no company (individuals) only see it under "*".
 *
 * @author DES
 * @date 01-10-2026
 */

export function webInterpretAllowed(
  companyId: string | null | undefined,
  rawList: string,
): boolean {
  const list = rawList
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  if (list.includes("*")) return true;
  return !!companyId && list.includes(String(companyId));
}

/** `AuthUser` carries the company under either spelling. */
export function companyIdOf(
  user: { company_id?: unknown; companyId?: unknown } | null | undefined,
): string | null {
  const id = user?.company_id ?? user?.companyId;
  return typeof id === "string" || typeof id === "number" ? String(id) : null;
}
